module.exports = "/img/_/_/_/assets/images/icon//rare.png?0004478071b8a910e1c734c62e5bf0ae";